'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});


var Vue = require('vue');

exports.default = Vue.component('input-text', {
    props: ['value', 'label', 'type', 'showPlainText'],
    data: function data() {
        return {
            plainTextEnabled: false,
            hasFocus: false
        };
    },
    computed: {
        currentValue: {
            get: function getCurrentValue() {
                return this.value;
            },
            set: function setCurrentValue(newVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        updateValue: function updateValue(newValue) {
            this.$emit('input', newValue);
        },
        isEdgeBrowser: function isEdgeBrowser() {
            return navigator.appVersion.indexOf('Edge') > -1;
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/utils/InputText.vue
// module id = gg+e
// module chunks = 1